<template lang="pug">
  .timer-wrap
    .timer
      .time {{ formatTime }}
</template>

<script>
export default {
  name: 'Timer',
  props: {
    value: {
      type: Boolean, // timer on
      default: false
    },
    seconds: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    min: 0,
    sec: 0,
    timerObj: null
  }),
  computed: {
    formatTime () {
      let timeStrings = [
        this.min.toString(),
        this.sec.toString()
      ].map((str) => {   
        return `0${str}`.slice(-2)
      })
      return timeStrings[0] + ":" + timeStrings[1]
    }
  },
  watch: {
    value (v) {
      this.clear()
      this.min = 0
      this.sec = 0

      if (v) {
        this.start()
        return
      }
    }
  },
  mounted () {
    if (this.value) {
      this.start()
    }
  },
  methods: {
    count () {
      if (this.sec <= 0 && this.min >= 1) {
        this.min --;
        this.sec = 59;
      } else if(this.sec <= 0 && this.min <= 0) {
        this.clear();
      } else {
        this.sec --;
      }
    },
    start () {
      this.min = Math.floor(this.seconds / 60)
      this.sec = this.seconds % 60
      this.timerObj = setInterval(this.count, 1000)
    },
    clear () {
      clearInterval(this.timerObj)
    }
  }
}
</script>

<style lang="styl" scoped>
  .timer-wrap
    display flex
    align-items center
    justify-content center

  >>>
    .time
      font-size 3em
</style>
